// Exact identity-to-route contract from data/content-route-manifest.csv.
// Editorial source gaps remain recorded in public-catalog.ts; routes do not imply translated content.
export const contentRoutes: readonly { id: string; type: 'category' | 'product' | 'news'; it: string; en: string }[] = [
  {
    "id": "prd-contenitori-terziari-esamed-endmed",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed-endmed",
    "en": "/en/products/transport-systems/tertiary-container-esamed-endmed"
  },
  {
    "id": "prd-centrifuga-centric-cf-108r-gr",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/centrifuga-centric-cf-108r-gr",
    "en": "/en/products/laboratory-equipment/centrifuga-centric-cf-108r-gr"
  },
  {
    "id": "prd-eugenio-esamed",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/eugenio-esamed",
    "en": "/en/products/transport-systems/eugenio-2"
  },
  {
    "id": "prd-poch100i-sysmex",
    "type": "product",
    "it": "/it/prodotti/point-of-care-testing/poch100i-sysmex",
    "en": "/en/products/point-of-care-testing/poch100i-sysmex"
  },
  {
    "id": "prd-ca0ca1-bonraybio",
    "type": "product",
    "it": "/it/prodotti/infertilita/ca0ca1-bonraybio",
    "en": "/en/products/infertility/ca0ca1-bonraybio"
  },
  {
    "id": "prd-centrifuga-mf48-48r-domel",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/centrifuga-mf48-48r-domel",
    "en": "/en/products/laboratory-equipment/centrifuga-domel-mf48"
  },
  {
    "id": "prd-analizzatore-biochimico-a-secco-automatico-sd1",
    "type": "product",
    "it": "/it/prodotti/point-of-care-testing/analizzatore-biochimico-a-secco-automatico-sd1",
    "en": "/en/products/point-of-care-testing/analizzatore-biochimico-a-secco-automatico-sd1"
  },
  {
    "id": "prd-r11-plus-bonraybio",
    "type": "product",
    "it": "/it/prodotti/infertilita/r11-plus-bonraybio",
    "en": "/en/products/infertility/r11-plus-bonraybio"
  },
  {
    "id": "prd-r10-bonraybio",
    "type": "product",
    "it": "/it/prodotti/infertilita/r10-bonraybio",
    "en": "/en/products/infertility/r10-bonraybio"
  },
  {
    "id": "prd-c-kup-bonraybio",
    "type": "product",
    "it": "/it/prodotti/infertilita/c-kup-bonraybio",
    "en": "/en/products/infertility/c-kup-bonraybio"
  },
  {
    "id": "prd-accre8-immunometria",
    "type": "product",
    "it": "/it/prodotti/point-of-care-testing/accre8-immunometria",
    "en": "/en/products/point-of-care-testing/accre8-immunometria"
  },
  {
    "id": "prd-esapoct-gestione-poct",
    "type": "product",
    "it": "/it/prodotti/tracciabilita/esapoct-gestione-poct",
    "en": "/en/products/traceability/esapoct-gestione-poct"
  },
  {
    "id": "prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette",
    "type": "product",
    "it": "/it/prodotti/tracciabilita/samtrace-sistema-esamed-per-la-tracciabilita-delle-provette",
    "en": "/en/products/traceability/samtrace-sistema-esamed-per-la-tracciabilita-delle-provette"
  },
  {
    "id": "prd-emotrace-tracciabilita-sangue",
    "type": "product",
    "it": "/it/prodotti/tracciabilita/emotrace-tracciabilita-sangue",
    "en": "/en/products/traceability/emotrace"
  },
  {
    "id": "prd-piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari",
    "en": "/en/products/transport-systems/cooling-plates"
  },
  {
    "id": "prd-accessori-contenitore-secondario-bios",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/accessori-contenitore-secondario-bios",
    "en": "/en/products/transport-systems/accessories-for-bios"
  },
  {
    "id": "prd-contenitore-secondario-plasmapack",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-plasmapack",
    "en": "/en/products/transport-systems/plasmapack-secondary-container"
  },
  {
    "id": "prd-contenitore-secondario-busta-campioni-biologici",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-busta-campioni-biologici",
    "en": "/en/products/transport-systems/bag-secondary-containers"
  },
  {
    "id": "prd-contenitore-secondario-kartell-campioni-biologici",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-kartell-campioni-biologici",
    "en": "/en/products/transport-systems/contenitore-secondario-kartell-campioni-biologici"
  },
  {
    "id": "prd-contenitore-terziario-a-basso-spessore-samed",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitore-terziario-a-basso-spessore-samed",
    "en": "/en/products/transport-systems/slimline-tertiary-containers"
  },
  {
    "id": "prd-celle-frigorifere",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/celle-frigorifere",
    "en": "/en/products/laboratory-equipment/celle-frigorifere"
  },
  {
    "id": "prd-frigoriferi-congelatori-portatili",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/frigoriferi-congelatori-portatili",
    "en": "/en/products/laboratory-equipment/frigoriferi-congelatori-portatili"
  },
  {
    "id": "prd-frigoriferi-medicali-a-due-temperature",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali_a_due_temperature",
    "en": "/en/products/laboratory-equipment/frigoriferi_medicali_a_due_temperature"
  },
  {
    "id": "prd-frigoemoteche-congelatori",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/frigoemoteche-congelatori",
    "en": "/en/products/laboratory-equipment/frigoemoteche-congelatori"
  },
  {
    "id": "prd-congelatori-da-laboratorio",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/congelatori-da-laboratorio",
    "en": "/en/products/laboratory-equipment/congelatori-da-laboratorio"
  },
  {
    "id": "prd-flashbot-pudu-smanno-camminatore",
    "type": "product",
    "it": "/it/prodotti/preanalitica/flashbot_pudu_smanno_camminatore",
    "en": "/en/products/preanalytics/flashbot_pudu_smanno_camminatore"
  },
  {
    "id": "prd-tt-2000-s-iqvision-endmed",
    "type": "product",
    "it": "/it/prodotti/preanalitica/tt-2000-s-iqvision-endmed",
    "en": "/en/products/preanalytics/tt-2000-s-iqvision-endmed"
  },
  {
    "id": "prd-tt-2000-s-endmed",
    "type": "product",
    "it": "/it/prodotti/preanalitica/tt-2000-s_endmed",
    "en": "/en/products/preanalytics/tt-2000-s_endmed"
  },
  {
    "id": "prd-x3-pro-semen-quality-analyzer",
    "type": "product",
    "it": "/it/prodotti/infertilita/x3-pro-semen-quality-analyzer",
    "en": "/en/products/infertility/x3-pro-semen-quality-analyzer"
  },
  {
    "id": "prd-tipos-olpaso",
    "type": "product",
    "it": "/it/prodotti/preanalitica/tipos-olpaso",
    "en": "/en/products/preanalytics/tipos-olpaso"
  },
  {
    "id": "prd-mindray-fa-n-series",
    "type": "product",
    "it": "/it/prodotti/microbiologia/mindray-fa-n-series",
    "en": "/en/products/microbiology/mindray-fa-n-series"
  },
  {
    "id": "prd-sg1",
    "type": "product",
    "it": "/it/prodotti/point-of-care-testing/sg1",
    "en": "/en/products/point-of-care-testing/sg1"
  },
  {
    "id": "prd-mindray-af-300",
    "type": "product",
    "it": "/it/prodotti/microbiologia/mindray-af-300",
    "en": "/en/products/microbiology/mindray-af-300"
  },
  {
    "id": "prd-cpa-easynat-real-time-molecular-diagnostic-system-vet",
    "type": "product",
    "it": "/it/prodotti/point-of-care-testing/cpa-easynat-real-time-molecular-diagnostic-system-vet",
    "en": "/en/products/point-of-care-testing/cpa-easynat"
  },
  {
    "id": "prd-centrifuga-domel-centric-350",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/centrifuga-domel-centric-350",
    "en": "/en/products/laboratory-equipment/centrifuga-domel-centric-350"
  },
  {
    "id": "prd-esaliva-dispositivo-per-la-raccolta-della-saliva",
    "type": "product",
    "it": "/it/prodotti/sistemi-di-prelievo/esaliva-dispositivo-per-la-raccolta-della-saliva",
    "en": "/en/products/collection-systems/esaliva-saliva-collection-device"
  },
  {
    "id": "prd-dc-2000-sl-stappatore",
    "type": "product",
    "it": "/it/prodotti/preanalitica/dc-2000-sl-stappatore",
    "en": "/en/products/preanalytics/dc-2000-sl-stappatore"
  },
  {
    "id": "prd-eugenio",
    "type": "product",
    "it": "/it/prodotti/preanalitica/eugenio",
    "en": "/en/products/preanalytics/eugenio"
  },
  {
    "id": "prd-x12-pro-semen-analysis-system",
    "type": "product",
    "it": "/it/prodotti/infertilita/x12-pro-semen-analysis-system",
    "en": "/en/products/infertility/x12-pro-semen-analysis-system"
  },
  {
    "id": "prd-accessori-prelievo",
    "type": "product",
    "it": "/it/prodotti/sistemi-di-prelievo/accessori_prelievo",
    "en": "/en/products/collection-systems/accessori_prelievo"
  },
  {
    "id": "prd-provette-bd",
    "type": "product",
    "it": "/it/prodotti/sistemi-di-prelievo/provette-bd",
    "en": "/en/products/collection-systems/provette-bd"
  },
  {
    "id": "prd-esatrace",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/esatrace",
    "en": "/en/products/transport-systems/esatrace"
  },
  {
    "id": "prd-portaprovette",
    "type": "product",
    "it": "/it/prodotti/preanalitica/portaprovette",
    "en": "/en/products/preanalytics/portaprovette"
  },
  {
    "id": "prd-contenitori-terziari-esamed",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitori-terziari-esamed",
    "en": "/en/products/transport-systems/contenitori-terziari-esamed"
  },
  {
    "id": "prd-contenitore-secondario-bios-campioni-biologici",
    "type": "product",
    "it": "/it/prodotti/soluzioni-per-trasporto/contenitore-secondario-bios-campioni-biologici",
    "en": "/en/products/transport-systems/bios"
  },
  {
    "id": "prd-frigoriferi-medicali",
    "type": "product",
    "it": "/it/prodotti/attrezzature-da-laboratorio/frigoriferi_medicali",
    "en": "/en/products/laboratory-equipment/frigoriferi_medicali"
  },
  {
    "id": "prd-x1-pro-se-semen-quality-analyzer",
    "type": "product",
    "it": "/it/prodotti/sistemi-di-prelievo/x1-pro-se-semen-quality-analyzer",
    "en": "/en/products/collection-systems/x1-pro-se-semen-quality-analyzer"
  },
  {
    "id": "cat-laboratory-equipment",
    "type": "category",
    "it": "/it/categoria/attrezzature-da-laboratorio",
    "en": "/en/category/laboratory-equipment"
  },
  {
    "id": "cat-infertility",
    "type": "category",
    "it": "/it/categoria/infertilita",
    "en": "/en/category/infertility"
  },
  {
    "id": "cat-microbiology",
    "type": "category",
    "it": "/it/categoria/microbiologia",
    "en": "/en/category/microbiology"
  },
  {
    "id": "cat-poct",
    "type": "category",
    "it": "/it/categoria/point-of-care-testing",
    "en": "/en/category/point-of-care-testing"
  },
  {
    "id": "cat-preanalytics",
    "type": "category",
    "it": "/it/categoria/preanalitica",
    "en": "/en/category/preanalytics"
  },
  {
    "id": "cat-collection-systems",
    "type": "category",
    "it": "/it/categoria/sistemi-di-prelievo",
    "en": "/en/category/collection-systems"
  },
  {
    "id": "cat-transport-systems",
    "type": "category",
    "it": "/it/categoria/soluzioni-per-trasporto",
    "en": "/en/category/transport-systems"
  },
  {
    "id": "cat-traceability",
    "type": "category",
    "it": "/it/categoria/tracciabilita",
    "en": "/en/category/traceability"
  },
  {
    "id": "news-simti-2026-workshop-esamed",
    "type": "news",
    "it": "/it/news?article=simti-2026-workshop-esamed",
    "en": "/en/news?article=esamed-workshop-simti-2026"
  },
  {
    "id": "news-simti-2026",
    "type": "news",
    "it": "/it/news?article=simti-2026",
    "en": "/en/news?article=5312"
  },
  {
    "id": "news-amcli-2026",
    "type": "news",
    "it": "/it/news?article=amcli-2026",
    "en": "/en/news?article=5310"
  },
  {
    "id": "news-medlab-middle-east-2024",
    "type": "news",
    "it": "/it/news?article=medlab-middle-east-2024",
    "en": "/en/news?article=medlab-middle-east-2024"
  },
  {
    "id": "news-nuovi-prodotti-di-preanalitica-decapper-e-recapper",
    "type": "news",
    "it": "/it/news?article=nuovi-prodotti-di-preanalitica-decapper-e-recapper",
    "en": "/en/news?article=new-preanalytics-products-detapper-and-recapper"
  },
  {
    "id": "news-convegno-poct-udine",
    "type": "news",
    "it": "/it/news?article=convegno-poct-udine",
    "en": "/en/news?article=poct-conference-in-udine"
  },
  {
    "id": "news-articolo-de-osservatorio-gruppo24ore",
    "type": "news",
    "it": "/it/news?article=articolo-de-osservatorio-gruppo24ore",
    "en": "/en/news?article=articolo-de-osservatorio-gruppo24ore"
  },
  {
    "id": "news-eugenio-lettore-automatico-barcode-delle-provette",
    "type": "news",
    "it": "/it/news?article=eugenio-lettore-automatico-barcode-delle-provette",
    "en": "/en/news?article=eugenio-automatic-tubes-barcode-reader"
  },
  {
    "id": "news-medica-2022",
    "type": "news",
    "it": "/it/news?article=medica-2022",
    "en": "/en/news?article=medica-2022"
  },
  {
    "id": "news-nuove-strumentazioni-veterinaria",
    "type": "news",
    "it": "/it/news?article=nuove-strumentazioni-veterinaria",
    "en": "/en/news?article=new-veterinary-equipment"
  },
  {
    "id": "news-il-nostro-stand-scivac-rimini",
    "type": "news",
    "it": "/it/news?article=il-nostro-stand-scivac-rimini",
    "en": "/en/news?article=our-stand-at-the-scivac-rimini"
  },
  {
    "id": "news-test-per-il-vaiolo-delle-scimmie",
    "type": "news",
    "it": "/it/news?article=test-per-il-vaiolo-delle-scimmie",
    "en": "/en/news?article=monkeypox-test"
  },
  {
    "id": "news-scivac-rimini-2022",
    "type": "news",
    "it": "/it/news?article=scivac-rimini-2022",
    "en": "/en/news?article=scivac-rimini-2022"
  },
  {
    "id": "news-soluzioni-complete-per-diagnostica-covid-19",
    "type": "news",
    "it": "/it/news?article=soluzioni-complete-per-diagnostica-covid-19",
    "en": "/en/news?article=complete-solutions-for-covid-19-diagnostics"
  },
  {
    "id": "news-fornitura-emergency-poct",
    "type": "news",
    "it": "/it/news?article=fornitura-emergency-poct",
    "en": "/en/news?article=poct-emergency-suppliers"
  },
  {
    "id": "news-cpa-easynat-real-time-molecular-diagnostic-system",
    "type": "news",
    "it": "/it/news?article=cpa-easynat-real-time-molecular-diagnostic-system",
    "en": "/en/news?article=cpa-easynat-real-time-molecular-diagnostic-system"
  },
  {
    "id": "news-covid-19-sp-anticorpi-neutralizzanti",
    "type": "news",
    "it": "/it/news?article=covid-19-sp-anticorpi-neutralizzanti",
    "en": "/en/news?article=covid-19-sp-immune-responses"
  },
  {
    "id": "news-frend-nanoentek",
    "type": "news",
    "it": "/it/news?article=frend-nanoentek",
    "en": "/en/news?article=frend-nanoentek"
  }
]
